import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'
Vue.use(Router)
export const constantRouterMap = [
  //不属于菜单页面
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  // 首页 0
  {
    path: '',
    redirect: '/home',
    component: Layout,
    meta: {
      title: '首页',
      icon: 'el-icon-s-home',
      id: 0
    },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'el-icon-s-home' },
    }]
  },
  // 消息管理 1
  {
    path: '/replay',
    redirect: '/replay/replay',
    name: 'replayMain',
    component: Layout,
    meta: {
      title: '消息列表',
      icon: 'el-icon-message',
      id: 1
    },
    children: [{
      path: 'replay',
      name: 'replay',
      component: () => import('@/views/replay/replay/index'),
      meta: { title: '素材管理', children_index: 1, icon: 'el-icon-tickets' }
    },
    {
      path: 'replayList',
      name: 'replayList',
      component: () => import('@/views/replay/replay/list'),
      meta: { title: '素材列表', is_children: true, children_path: '/replay/replay', noKeepAlive: true },
      hidden: true,
    },
    {
      path: 'keyReplay',
      name: 'keyReplay',
      component: () => import('@/views/replay/keyReplay/index'),
      meta: { title: '关键字回复', children_index: 1, noKeepAlive: true, icon: 'el-icon-news' },
    },
    {
      path: 'addReplay',
      name: 'addReplay',
      component: () => import('@/views/replay/keyReplay/addReplay'),
      meta: { title: '添加回复', is_children: true, children_path: '/replay/keyReplay', noKeepAlive: true },
      hidden: true
    },
    {
      path: 'followReplay',
      name: 'followReplay',
      component: () => import('@/views/replay/follow/index'),
      meta: { title: '关注后回复', icon: 'el-icon-view', noKeepAlive: true }
    }],
  },
  // 文章管理 2
  {
    path: '/article',
    redirect: '/article/directory',
    name: 'article',
    component: Layout,
    meta: {
      title: '文章管理',
      icon: 'el-icon-document',
      id: 2
    },
    children: [{
      path: 'directory',
      name: 'directory',
      component: () => import('@/views/article/directory/index'),
      meta: { title: '目录管理', icon: 'el-icon-film', noKeepAlive: true }
    },
    {
      path: 'essay',
      name: 'Essay',
      component: () => import('@/views/article/essay/index'),
      meta: { title: '文章管理', icon: 'el-icon-document' }
    },
    {
      path: 'banner',
      name: 'Banner',
      component: () => import('@/views/article/banner/index'),
      meta: { title: 'banner管理', icon: 'el-icon-picture', noKeepAlive: true }
    },
    {
      path: 'add',
      name: 'BannerAdd',
      component: () => import('@/views/article/banner/add'),
      meta: { title: 'banner管理', icon: 'el-icon-picture', is_children: true, children_path: '/article/banner', noKeepAlive: true },
      hidden: true
    },
    {
      path: 'essayAdd',
      name: 'EssayAdd',
      component: () => import('@/views/article/essay/add'),
      meta: { title: '新增文章', icon: 'el-icon-document', is_children: true, children_path: '/article/essay', noKeepAlive: true },
      hidden: true
    },
    {
      path: 'videoAdd',
      name: 'videoAdd',
      component: () => import('@/views/article/essay/addVideo'),
      meta: { title: '新增短视频', icon: 'el-icon-document', is_children: true, children_path: '/article/essay', noKeepAlive: true },
      hidden: true
    },
    {
      path: 'author',
      name: 'author',
      component: () => import('@/views/article/author/index'),
      meta: { title: '作者管理', icon: 'el-icon-edit' }
    },
    {
      path: 'authorAdd',
      name: 'authorAdd',
      component: () => import('@/views/article/author/add'),
      meta: { title: '新增作者', icon: 'el-icon-document', is_children: true, children_path: '/article/author', noKeepAlive: true },
      hidden: true
    },],
  },

  // 帖子管理 14
  {
    path: '/community',
    redirect: '/community/index',
    name: 'community',
    component: Layout,
    meta: {
      title: '帖子管理',
      icon: ' icontiezi',
      id: 14
    },
    children: [
      {
        path: 'communityMan',
        name: 'CommunityMan',
        component: () => import('@/views/community/index/index'),
        meta: { title: '帖子管理', icon: ' icontiezi' }
      },
      {
        path: 'communityAdd',
        name: 'CommunityAdd',
        component: () => import('@/views/community/index/add'),
        meta: { title: '新增帖子', icon: ' iconxinjiantiezi', is_children: true, children_path: '/community/communityMan', noKeepAlive: true  },
        hidden: true
      },
      {
        path: 'communitySettings',
        name: 'CommunitySettings',
        component: () => import('@/views/community/index/settings'),
        meta: { title: '内容频率设置', icon: 'iconxinjiantiezi', is_children: true, children_path: '/community/communityMan', noKeepAlive: true },
        hidden: true
      },
      {
        path: 'communityReport',
        name: 'CommunityReport',
        component: () => import('@/views/community/index/report'),
        meta: { title: '举报管理', icon: ' iconxinjiantiezi' },
      },
      {
        path: 'commentMan',
        name: 'CommentMan',
        component: () => import('@/views/community/comment/index'),
        meta: { title: '评论管理', icon: ' iconxinjiantiezi', is_children: true, children_path: '/community/communityMan', noKeepAlive: true  },
        hidden: true
      },
      {
        path: 'topic',
        name: 'Topic',
        component: () => import('@/views/community/topic/index'),
        meta: { title: '话题管理', icon: ' iconhuati' }
      }
    ],
  },
  // 客户管理 3
  {
    path: '/client',
    name: 'Client',
    meta: {
      title: '客户管理',
      icon: 'el-icon-s-finance',
      id: 3
    },
    component: Layout,
    children: [
      {
        path: 'clientMan',
        name: 'ClientMan',
        component: () => import('@/views/client/clientMan'),
        meta: { title: '客户管理', icon: 'el-icon-user-solid', noKeepAlive: true },
      },
      {
        path: 'growDetail',
        name: 'GrowDetail',
        component: () => import('@/views/client/growDetail'),
        meta: { title: '成长值详情', is_children: true, children_path: '/client/clientMan', noKeepAlive: true },
        hidden: true
      },

    ],
  },
  // 数据管理 15
  {
    path: '/dataMan',
    name: 'dataMan',
    meta: { title: '数据管理',  icon: 'el-icon-s-marketing', id: 15 },
    component: Layout,
    children: [
      {
        path: 'growData',
        name: 'GrowData',
        component: () => import('@/views/dataMan/growData'),
        meta: { title: '成长值', icon: '', noKeepAlive: true },
      },
      {
        path: 'beansData',
        name: 'BeansData',
        component: () => import('@/views/dataMan/beansData'),
        meta: { title: '彩虹豆', icon: '', noKeepAlive: true }
      },
    ]
  },
  // 活动管理 16
  {
    path: '/activity',
    name: 'Activity',
    meta: { title: '活动管理',  icon: 'el-icon-position', id: 14 },
    component: Layout,
    children: [
      {
        path: 'member',
        name: 'Member',
        component: () => import('@/views/activity/member/index'),
        meta: { title: '社员活动', icon: 'el-icon-chat-dot-square', noKeepAlive: true },
      },
      // {
      //   path: 'public',
      //   name: 'Public',
      //   component: () => import('@/views/activity/public/index'),
      //   meta: { title: '公益活动', icon: 'el-icon-s-order', noKeepAlive: true }
      // },
    ]
  },
   // 活动管理 16
   {
    path: '/contribution',
    name: 'Contribution',
    meta: { title: '贡献奖励管理',  icon: 'el-icon-folder-opened', id: 16 },
    component: Layout,
    children: [
      {
        path: 'task',
        name: 'Tasks',
        component: () => import('@/views/contribution/index'),
        meta: { title: '贡献奖励任务', icon: 'el-icon-folder-add', noKeepAlive: true },
      },
      {
        path: 'detailed',
        name: 'Detailed',
        component: () => import('@/views/contribution/detailed'),
        meta: { title: '用户贡献奖励发放明细', icon: 'el-icon-c-scale-to-original', noKeepAlive: true },
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/contribution/statistics'),
        meta: { title: '贡献奖励数据统计', icon: 'el-icon-c-scale-to-original', noKeepAlive: true },
      },
      {
        path: 'addContribution',
        name: 'AddContribution',
        component: () => import('@/views/contribution/addContribution'),
        meta: { title: '新建贡献奖励任务', is_children: true, children_path: '/contribution/addContribution', noKeepAlive: true },
        hidden: true
      },
      {
        path: 'gxDetail',
        name: 'GxDetail',
        component: () => import('@/views/contribution/gxDetail'),
        meta: { title: '新建贡献奖励任务', is_children: true, children_path: '/contribution/gxDetail', noKeepAlive: true },
        hidden: true
      },
    ]
  },
  // {
  //   path: '/gxData',
  //   name: 'GxData',
  //   meta: { title: '分红管理',  icon: 'el-icon-folder-opened', id: 15 },
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'gxData',
  //       name: 'GxData',
  //       component: () => import('@/views/gxData/index'),
  //       meta: { title: '分红管理', icon: 'el-icon-menu', noKeepAlive: true },
  //     }
  //   ]
  // },
  // 群发管理4
  {
    path: '/groupMsg',
    name: 'GroupMsg',
    meta: {
      title: '群发管理',
      icon: 'el-icon-s-promotion',
      id: 4
    },
    component: Layout,
    children: [
      {
        path: 'workerMsg',
        name: 'WorkerMsg',
        component: () => import('@/views/groupMsg/worker'),
        meta: { title: '客服群发消息', noKeepAlive: true, children_path: '/groupMsg/workerMsg', icon: 'el-icon-s-comment' },
      },
      {
        path: 'workerMsgAdd',
        name: 'WorkerMsgAdd',
        component: () => import('@/views/groupMsg/workerAdd'),
        meta: { title: '新建手动群发', is_children: true, children_path: '/groupMsg/workerMsg', noKeepAlive: true },
        hidden: true
      },
      {
        path: 'templateMsg',
        name: 'TemplateMsg',
        component: () => import('@/views/groupMsg/template'),
        meta: { title: '模版群发消息', is_children: true, children_path: '/groupMsg/templateMsg', noKeepAlive: true, icon: 'el-icon-s-order' },
      },
      {
        path: 'templateAdd',
        name: 'TemplateAdd',
        component: () => import('@/views/groupMsg/templateAdd'),
        meta: { title: '新建模版群发', is_children: true, children_path: '/groupMsg/templateMsg', noKeepAlive: true },
        hidden: true
      },
      {
        path: 'templateHighMsg',
        name: 'TemplateHighMsg',
        component: () => import('@/views/groupMsg/templateHigh'),
        meta: { title: '高级群发', is_children: true, children_path: '/groupMsg/templateHighMsg', noKeepAlive: true, icon: 'el-icon-s-claim' },
      },
      {
        path: 'templateHighAdd',
        name: 'TemplateHighAdd',
        component: () => import('@/views/groupMsg/templateHighAdd'),
        meta: { title: '新建高级群发', is_children: true, children_path: '/groupMsg/templateHighMsg', noKeepAlive: true },
        hidden: true
      },
    ]
  },
  // 专题管理 6
  {
    path: '/subject',
    name: 'Subject',
    meta: {
      title: '专题管理',
      icon: 'el-icon-s-flag',
      id: 6
    },
    component: Layout,
    children: [
      {
        path: 'task',
        name: 'Task',
        component: () => import('@/views/subject/task/index'),
        meta: { title: '任务专题', icon: 'el-icon-s-flag', noKeepAlive: true },
      },
      {
        path: 'taskAdd',
        name: 'TaskAdd',
        component: () => import('@/views/subject/task/add'),
        meta: { title: '新增任务', is_children: true, children_path: '/subject/task', icon: 'el-icon-s-flag', noKeepAlive: true },
        hidden: true
      },
    ]
  },
  // 积分管理 7
  {
    path: '/integral',
    name: 'integral',
    meta: {
      title: '积分管理',
      icon: 'el-icon-medal',
      id: 7
    },
    component: Layout,
    children: [
      {
        path: 'grant',
        name: 'grant',
        component: () => import('@/views/integral/grant/index'),
        meta: { title: '积分发放', icon: 'el-icon-finished', noKeepAlive: true },
      },
      {
        path: 'grantDetail',
        name: 'grantDetail',
        component: () => import('@/views/integral/grant/details'),
        meta: { title: '新建积分任务', is_children: true, children_path: '/integral/grant', noKeepAlive: true },
        hidden: true
      },
      // {
      //   path: 'behavior',
      //   name: 'behavior',
      //   component: () => import('@/views/integral/behavior/index'),
      //   meta: { title: '积分行为', icon: 'el-icon-takeaway-box', noKeepAlive: true }
      // },
      {
        path: 'record',
        name: 'record',
        component: () => import('@/views/integral/record/index'),
        meta: { title: '积分记录', icon: 'el-icon-document-copy', noKeepAlive: true }
      },
    ]
  },
  // 组织架构 8
  {
    path: '/company',
    name: 'Company',
    meta: {
      title: '组织架构',
      icon: 'el-icon-s-tools',
      id: 8
    },
    component: Layout,
    children: [
      {
        path: 'companyMan',
        name: 'CompanyMan',
        component: () => import('@/views/company/index'),
        meta: { title: '组织架构', icon: 'el-icon-s-tools' },
      },
    ]
  },
  // 供应商管理 9
  {
    path: '/supplier',
    name: 'Supplier',
    meta: {
      title: '供应链管理',
      icon: 'el-icon-connection',
      id: 9
    },
    component: Layout,
    children: [
      {
        path: 'supplierMan',
        name: 'SupplierMan',
        component: () => import('@/views/supplier/index'),
        meta: { title: '供应商管理', icon: 'el-icon-s-custom' },
      },
      {
        path: 'supplierCate',
        name: 'SupplierCate',
        component: () => import('@/views/supplier/cateIndex'),
        meta: { title: '分类管理', icon: 'el-icon-s-grid' },
      },
      {
        path: 'productMan',
        name: 'ProductMan',
        component: () => import('@/views/product/index'),
        meta: { title: '商品管理', icon: 'el-icon-s-goods' },
      },
      {
        path: 'orderMan',
        name: 'OrderMan',
        component: () => import('@/views/supplier/orderIndex'),
        meta: { title: '销售单管理', icon: 'el-icon-tickets' },
      },
      {
        path: 'allotMan',
        name: 'AllotMan',
        component: () => import('@/views/supplier/allotIndex'),
        meta: { title: '分配单管理', icon: 'el-icon-document' },
      },
      {
        path: 'allotRecord',
        name: 'AllotRecord',
        component: () => import('@/views/supplier/AllotRecord'),
        meta: { title: '分配记录', is_children: true, children_path: '/supplier/allotMan', icon: 'el-icon-s-flag', noKeepAlive: true },
        hidden: true
      },
      {
        path: 'expressMan',
        name: 'ExpressMan',
        component: () => import('@/views/supplier/expressMan'),
        meta: { title: '发货单管理', icon: 'el-icon-truck' },
      },
    ]
  },
  // 产品档案管理 10
  {
    path: '/productArchive',
    name: 'ProductArchive',
    meta: {
      title: '产品档案管理',
      icon: 'el-icon-video-camera-solid',
      id: 10
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'List',
        component: () => import('@/views/productArchive/index'),
        meta: { title: '产品档案管理', icon: 'el-icon-video-camera-solid' },
      },
      {
        path: 'add',
        name: 'Add',
        component: () => import('@/views/productArchive/add'),
        meta: { title: '产品档案信息', is_children: true, children_path: '/productArchive/list', icon: 'el-icon-video-camera-solid', noKeepAlive: true },
        hidden: true
      },
    ]
  },
  // 通知管理 11
  {
    path: '/noticeMan',
    name: 'NoticeMan',
    meta: {
      title: '通知管理',
      icon: 'el-icon-chat-line-square',
      id: 11
    },
    component: Layout,
    children: [
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/notice/index'),
        meta: { title: '通知管理', icon: 'el-icon-chat-line-square' },
      }
    ]
  },
  // 溯源管理 12
  {
    path: '/traceMan',
    name: 'TraceMan',
    meta: {
      title: '溯源管理',
      icon: 'el-icon-share',
      id: 12
    },
    component: Layout,
    children: [
      {
        path: 'tracing',
        name: 'Tracing',
        component: () => import('@/views/trace/index'),
        meta: { title: '溯源管理', icon: 'el-icon-share' },
      }
    ]
  },
  // 快捷管理 5
  {
    path: '/shortcut',
    name: 'Shortcut',
    meta: {
      title: '快捷管理',
      icon: 'el-icon-s-help',
      id: 5
    },
    component: Layout,
    children: [
      {
        path: 'shortcutList',
        name: 'shortcutList',
        component: () => import('@/views/shortcut/index'),
        meta: { title: '快捷管理', icon: 'el-icon-s-help', noKeepAlive: true },
      }
    ]
  },
  // 账号管理 13
  {
    path: '/account',
    name: 'AccountMan',
    meta: {
      title: '账号管理',
      icon: 'el-icon-mobile-phone',
      id: 13
    },
    component: Layout,
    children: [
      {
        path: 'account',
        name: 'Account',
        component: () => import('@/views/account/index'),
        meta: { title: '我的账号', icon: 'el-icon-mobile-phone' },
      },
      {
        path: 'join',
        name: 'Join',
        component: () => import('@/views/account/join'),
        meta: { title: '接入类型', is_children: true, children_path: '/account/account', icon: 'el-icon-s-finance' },
        hidden: true
      },
    ]
  },
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js